import { combineReducers } from "redux";
import localstore_reducer from "./localstore_reducer";
import models_reducer from "./models_reducer";
import profile_reducer from "./profile_reducer";

export default combineReducers({
  profile: profile_reducer,
  localstore: localstore_reducer,
  models: models_reducer,
});
